import { formatNumber } from '@/utils/format';

// Shared cell renderers for the Provider Funds grids. formatNumber() returns 'N/A'
// for null, so these helpers wrap it to match the legacy render* JS functions.

export function renderNumber(value: number | null | undefined, decimals = 2): string {
  if (value == null || Number.isNaN(value)) return formatNumber(0, decimals);
  return formatNumber(value, decimals);
}

// IN/OUT/RC columns: 0 or null renders as a dash (legacy renderNumberOrDash).
export function renderNumberOrDash(value: number | null | undefined, decimals = 2): string {
  if (value == null || Number.isNaN(value) || value === 0) return '-';
  return formatNumber(value, decimals);
}

// Empty/null text renders as a dash (legacy renderTextOrDash).
export function renderTextOrDash(value: string | number | null | undefined): string {
  if (value == null) return '-';
  const s = String(value).trim();
  return s === '' ? '-' : s;
}

// DD/MM/YYYY HH:mm:ss (legacy renderDateTime).
export function renderDateTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(
    d.getMinutes(),
  )}:${p(d.getSeconds())}`;
}

// MMM YYYY (legacy renderPlMonth, e.g. "Oct 2026").
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export function renderPlMonth(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return `${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

// DD/MM/YYYY HH:mm (legacy renderPlDateTime).
export function renderPlDateTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

// monthKey = YYYY-MM for the Select Month dropdown.
export function monthKey(iso: string): string {
  const d = new Date(iso);
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}`;
}
